import {connect} from "react-redux";
import EmpToEmpListing from "./EmpToEmpListing";
import {bindActionCreators} from "redux";
import {
  getEmpMrfListing
} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
  pendingListing: state.MaterialRequistionForm.empMrfListing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEmpMrfListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmpToEmpListing);
